import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import API from "../lib/api";
import { Section } from "../components/Common";
import { useAuth } from "../lib/auth";
import MyBusinessOffersInline from "../components/MyBusinessOffersInline";
import { Plus, MapPin, Sparkles } from "lucide-react";

export default function MyBusinessPage() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [user, loading, navigate]);
  useEffect(() => {
    if (!user) return;
    API.get("/marketplace/my-businesses").then(({ data }) => setItems(data.items || [])).finally(() => setBusy(false));
  }, [user]);

  if (loading || !user) return <div className="app-container py-20 text-white/70">{t("common.loading")}</div>;
  return (
    <Section eyebrow={`— ${t("nav.marketplace")}`} title={t("marketplace.my_business_title")} subtitle={t("marketplace.my_business_sub")}>
      <div className="mb-6"><Link to="/marketplace/register" className="btn-primary text-sm inline-flex items-center gap-2" data-testid="add-business"><Plus className="w-4 h-4" /> {t("marketplace.list_business_cta")}</Link></div>
      {busy ? <div className="text-white/60 text-sm">{t("common.loading")}</div> : items.length === 0 ? (
        <div className="text-white/60 text-sm" data-testid="my-biz-empty">{t("marketplace.my_business_empty")}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="my-biz-grid">
          {items.map((b) => (
            <div key={b.business_id} className="card-surface overflow-hidden">
              {b.image && <div className="aspect-[16/10] overflow-hidden"><img src={b.image} alt={b.name} className="w-full h-full object-cover" /></div>}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-1">
                  <span className="eyebrow">{(b.category || "").replace(/-/g, " ")}</span>
                  <span className={`chip ${b.status === "active" ? "chip-active" : ""}`}>{b.status}</span>
                  {b.tier === "premium" && <span className="chip chip-active"><Sparkles className="w-3 h-3" /> {t("marketplace.premium")}</span>}
                </div>
                <div className="font-display text-lg">{b.name}</div>
                <div className="text-sm text-white/70 mt-1">{b.tagline}</div>
                <div className="text-xs text-white/55 mt-2 flex items-center gap-2"><MapPin className="w-3 h-3" /> {b.city}, {b.country}</div>
                {b.status === "active" && <Link to={`/marketplace/business/${b.slug}`} className="btn-ghost text-sm mt-3 inline-block">{t("marketplace.view_public_listing")}</Link>}
                {/* Phase 6.4 — propose member benefit offers on this business */}
                {b.status === "active" && <MyBusinessOffersInline business={b} />}
              </div>
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
